module.exports = __webpack_public_path__ + "images/landing/video-previews/short_ads_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/short_ads_2x.jpg
// module id = RCsF
// module chunks = 1